export const MODAL_TYPE = {
  ALLOCATE_BLOCK: 'ALLOCATE BLOCK',
  DEAL: 'DEAL',
  USERS: 'USERS',
  PRIME_BROKER: 'PRIME BROKER',
  CUTS: 'CUTS',
  CURRENCY_PAIRS: 'CURRENCY PAIRS',
  FIXING_SOURCE: 'FIXING SOURCE',
  TRADE: 'TRADE',
  TRADER: 'TRADER',
  TRADING_ACCOUNT: 'TRADING ACCOUNT',
  ENTITIES: 'ENTITIES',
  DEAL_REPORT_STATUS: 'DEAL REPORT STATUS',
  PERMISSION: 'PERMISSION'
}

export const MODAL_TITLE = {
  ALLOCATE_BLOCK: 'allocate block',
  NEW_CLIENT: 'new client',
  EDIT_CLIENT: 'edit client',
  NEW_DEAL: 'new deal',
  NEW_ENTITY: 'new entity',
  EDIT_ENTITY: 'edit entity',
  NEW_MARKET_MAKER: 'new market maker',
  EDIT_MARKET_MAKER: 'edit market maker',
  NEW_USER: 'new user',
  EDIT_USER: 'edit user',
  NEW_PRIME_BROKER: 'new prime broker',
  EDIT_PRIME_BROKER: 'edit prime broker',
  NEW_CUT: 'new cut',
  EDIT_CUT: 'edit cut',
  NEW_CURRENCY_PAIR: 'new currency pair',
  EDIT_CURRENCY_PAIR: 'edit currency pair',
  NEW_FIXING_SOURCE: 'new fixing source',
  EDIT_FIXING_SOURCE: 'edit fixing source',
  NEW_TRADE: 'new trade',
  EDIT_TRADE: 'edit trade',
  NEW_MARKET_TRADE: 'new market trade',
  NEW_CLIENT_TRADE: 'new client trade',
  DEAL_REPORT_STATUS: 'deal',
  CONVERSION_TRADE_REPORT_STATUS: 'trade',
  ADD_PERMISSIONS: 'add permissions',
  NEW_TRADER: 'new trader',
  NEW_TRADING_ACCOUNT: 'new trading account'
}

export const routes = {
  auth: '/auth',
  authToken: '/auth/token',
  barrierDirection: '/barrier/direction',
  client: '/client',
  clientPermission: '/client/permission',
  clientWithPrimeBroker: '/client/prime/broker',
  counterParty: '/counterparty',
  country: '/country',
  contractDistribution: '/contract/distribution',
  currency: '/currency',
  currencyNormalize: '/currency/normalize',
  cut: '/cut',
  currencyPair: '/currency/pair',
  currencyPrice: '/currency/price',
  dealExcel: '/deal/excel/',
  dealReport: '/deal/report',
  dealReportCsv: '/deal/report/csv/',
  dealReportTradeReportCsv: '/deal/report/trade/report/csv/',
  dealTypes: '/deal/type',
  entitlement: '/entitlement',
  fixingSource: '/fixing/source',
  marketMaker: '/market/maker',
  marketMakerPermission: '/market/maker/permission',
  makorCompany: '/makor/company',
  makorPrimeBroker: '/makor/prime/broker',
  pbAgreement: '/pb/agreement',
  productType: '/product/type',
  primeBroker: '/prime/broker',
  primeBrokerMapping: '/prime/broker/mapping',
  primeBrokerGroupEmail: '/prime/broker/group/email',
  entities: '/entities',
  entitiesPrimeBroker: '/entities/prime/broker',
  side: '/side',
  origin: '/side',
  city: '/timezone/city',
  tradeBlotter: '/trade/blotter',
  tradeReport: '/trade/report',
  tradingAccountTradersNormalize: '/trading/account/traders/normalize',
  tradingAccountPrimeBrokerNormalize: '/trading/account/prime/broker/normalize',
  tradeType: '/trade/type',
  tradeTypeGroup: '/trade/type/group',
  tradeDealType: '/trade/deal/type',
  tradeOrigin: '/trade/origin',
  tenor: '/tenor',
  timing: '/timing',
  tradeCounterparty: '/trade/counterparty',
  tradeSymbol: '/trade/symbol',
  optionStyle: '/option/style',
  allocateTradeCounterparty: '/trade/allocate/counterparty',
  trader: '/trader',
  resetPasswordEmail: '/auth/reset/password/email',
  resetPassword: '/auth/reset/password',
  user: '/user',
  userEntitlement: '/user/entitlement',
  addWidget: '/widget/add_widget',
  removeWidget: '/widget/remove_widget',
  getWidget: '/widget'
}

export const ACTION = {
  UPDATE: 'UPDATE',
  CREATE: 'CREATE'
}

export const leToolRoutes = {
  getStatus: '/get_status',
  generateCSV: '/status/generate_csv',
  getFileNames: '/get_filenames'
}

export const METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
}

export const DEAL_GROUP = {
  SPOT: 'Spot',
  VANILLA_OPTION: 'Vanilla Option',
  DIGITAL_OPTION: 'Digital Option',
  DIGITAL_KNOCK_IN_KNOCK_OUTS: 'Digital Knock-in/Knock-outs',
  DIGITAL_DOUBLES: 'Digital Doubles',
  DOUBLE_NO_TOUCH_OPTION: 'Double No-Touch Option',
  MORE_DOUBLES: 'More Doubles',
  TOUCH_OPTIONS: 'Touch Options',
  ENHANCED_REVERSE_OPTIONS: 'Enhanced Reverse Options',
  REMAINING_OPTIONS: 'Remaining Options',
  SWAP: 'Swap',
  FORWARD: 'Forward',
  NDF: 'NDF'
}

export const PAGES = {
  BOOKING: 'Booking',
  PNL_Attribution: 'P&L Attribution',
  STATIC: 'Static'
}

export const CURRENCY = {
  XDR: 'XDR',
  XUA: 'XUA',
  XSU: 'XSU',
  XAU: 'XAU',
  XPD: 'XPD',
  XPT: 'XPT',
  XAG: 'XAG'
}
export const TRADE_BLOTTER_STATUS = {
  DELETE: 'DELETE',
  WARNING_QUANTITY: 'WARNING QUANTITY',
  WARNING_EXPIRY: 'WARNING EXPIRY',
  WARNING_STRIKE: 'WARNING STRIKE',
  WARNING_PUT_CALL: 'WARNING PUT CALL',
  WARNING_CUT: 'WARNING CUT',
  WARNING_PRIME_BROKER: 'WARNING PRIME BROKER',
  NEW: 'NEW',
  NEW_END: 'NEW_END',
  UNION: 'UNION',
  CONVERSION: 'CONVERSION',
  ALLOCATED: 'Allocated',
  UNALLOCATED: 'Unallocated',
  STAGED: 'Staged',
  LIVE: 'Live',
  PENDING: 'Pending'
}

export const STAGING_STATUS = {
  LIVE: 'Live',
  STAGED: 'Staged',
  PENDING: 'Pending'
}

export const WARNING_MESSAGE = {
  UNGROUPED_TRADE: 'Ungrouped Trade',
  MISMATCHED_QUANTITIES: 'Mismatched quantities',
  MISMATCHED_SYMBOL_EXPIRY: 'Mismatched symbols expiry',
  MISMATCHED_SYMBOL_STRIKE: 'Mismatched symbols strike',
  MISMATCHED_SYMBOL_PUT_CALL: 'Mismatched symbols put call',
  MISMATCHED_SYMBOL_CUT: 'Mismatched symbols cut',
  MISMATCHED_PRIME_BROKER: 'Mismatched prime broker',
  DEAL_IS_UNALLOCATED: 'Deal is unallocated',
  DEAL_IS_STAGED: 'Deal not sent to prime broker',
  DEAL_IS_PENDING: 'Deal is pending',
  DEAL_IS_DELETED: 'Deal is deleted',
  TRADE_IS_PENDING: 'Trade is pending',
  CONVERSION_TRADE: 'Conversion Trade',
  CONVERSION_TRADE_IS_DELETED: 'Conversion Trade Is Deleted'
}

export const DIRECTION = {
  CLIENT: 'Client',
  MARKET_MAKER: 'Market Maker'
}

export const STATUS_CURRENCY_PAIR = {
  UP: 'UP',
  DOWN: 'DOWN',
  SAME: 'SAME'
}

export const SIGN = {
  PREV: 'PREV',
  NEXT: 'NEXT'
}

export const DATE_FORMAT = {
  DEAL_EXCEL_REPORT_DATE: 'YYYY-MM-DD-HH:mm:ss.SSS',
  REGULAR_DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  REGULAR_DATE: 'YYYY-MM-DD',
  BLOTTER_DATE_TIME: 'DD-MMM-YYYY HH:mm:ss',
  DEAL_STATUS_DATE: 'DD MMM YYYY HH:mm'
}

export const DEAL_TYPE = {
  SPOT: 'Spot',
  VANILLA_OPTION: 'Vanilla Option'
}

export const ERRORS = {
  number: key => `${key.replaceAll('_', ' ')} must be positive number`,
  alpha: key => `${key.replaceAll('_', ' ')} must be upper/lower case letters`,
  alphaNumeric: key => `${key.replaceAll('_', ' ')} must be upper/lower/number case letters`,
  required: key => `${key.replaceAll('_', ' ')} is required`,
  email: key => `${key.replaceAll('_', ' ')} is not valid`,
  least: number => `Choose at least ${number} options`,
  short: (key, number) => `${key.replaceAll('_', ' ')} must be at least ${number} characters`,
  length: (key, number) => `${key.replaceAll('_', ' ')} must be ${number} characters`,
  password: 'incorrect password'
}

export const REQUEST_INITIAL = {
  TRADE_BLOTTER: 'trade_blotter',
  ACTIVITY_BLOTTER: 'activity_blotter'
}

export const ACTION_REQUEST_INITIAL = {
  REMOVE: 'remove',
  SET: 'set'
}
